import {
  DeleteCommentDataFromViewer,
  UpdateCommentDataFromViewer
} from './annotationTypes';

export interface CapaFile {
  fileSize?: number;
  fileId?: string;
  fileName?: string;
}

export type FileCategory =
  | 'ERROR'
  | 'DRAWING_FILE'
  | 'IMAGE'
  | 'PDF'
  | 'TUTORIAL';

export enum EnumFileCategory {
  ERROR = 'ERROR',
  DRAWING_FILE = 'DRAWING_FILE',
  IMAGE = 'IMAGE',
  PDF = 'PDF'
}

export type ViewerMode = 'chat' | 'default' | 'TUTORIAL';

export interface ViewerCommunicateProps {
  viewerRef?: React.MutableRefObject<HTMLIFrameElement | null>;
  isAddingAnnotation?: boolean;
  onGetNewAnnotationData?: (comment: string) => Promise<void>;
  selectedAnnotationId?: string | null;
  onCloseAnnotationMobile?: () => void;
  onCancleAddAnnotationMobile: () => void;
  onDeleteAnnotation: (annotationId: string) => Promise<void>;
  onDeleteComment: (
    data: Omit<DeleteCommentDataFromViewer, 'modelId'>
  ) => Promise<void>;
  onUpdateComment: (
    data: Omit<UpdateCommentDataFromViewer, 'modelId'>
  ) => Promise<void>;
}

export interface ViewerAnnotationQuery {
  fileId?: string;
  annotationId?: string;
  commentId?: string;
  menu: 'viewer';
}
